<template>
  <div>
    <van-cell-group>
      <van-field
          v-model="captcha"
          label="验证码"
          placeholder="请输入验证码"
          clearable
          :error = "err"
          :error-message = "errMsg"
          @click = "()=>{this.err=false, this.errMsg=''}"
          center>
        <template #button>
          <img :src="captchaUrl"  @click="refreshCaptcha" class="captcha-image"/>
        </template>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
// import { ref } from 'vue';

export default {
  name: "VerifyCode",
  data() {
    return {
      captchaUrl: "",
      captcha:"",
      err:false,
      errMsg:"",
      timestamp:0,
      cacheUrl:""
    }
  },
  mounted() {
    this.refreshCaptcha();
  },
  watch: {
    captcha(){
      this.$emit("captchaWatch", this.captcha)
    }
  },
  methods:{
    clearError() {
      this.err = false;
      this.errMsg = '';
    },
    refreshCaptcha() {
      const ts = new Date().getTime();
      if(ts - this.timestamp<120000) {
        this.captchaUrl = `${this.cacheUrl}&ts=${ts}`;
        return
      }
      this.$captcha_http.get("/captcha/token?bid=passport").then((response) => {
        // handle success
        this.captchaUrl = response.data.data.url;
        this.cacheUrl = response.data.data.url
        this.timestamp = new Date().getTime()
        this.$emit("captchaToken", response.data.data.token)
      })
      return;
    }
  }
}
</script>

<style scoped>
.captcha-image {
  margin-left: 10px;
  height: 35px;
  cursor: pointer;
}
</style>
